import { useState, useEffect } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import {
    FaGithub,
    FaLinkedinIn,
    FaInstagram,
    FaEnvelope,
} from "react-icons/fa";

import { Link } from "react-scroll";

const Navbar = () => {
    const [navState, setnavState] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleMobileMenuToggle = () => {
        setMobileMenuOpen((prevState) => !prevState);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onNavScroll = () => {
        if (window.scrollY > 30) {
            setnavState(true);
        } else {
            setnavState(false);
        }
    };


    useEffect(() => {
        window.addEventListener("scroll", onNavScroll);
        return () => {
            window.removeEventListener("scroll", onNavScroll);
        };
    }, []);

    return (
        <div className="card inset-x-0 top-0 z-50 fixed">
            <div
                className={`${!navState
                        ? "flex items-center text-white font-semibold justify-between px-4 py-4 lg:px-20 "
                        : "fixed md:fixed top-0 left-0  right-0 text-black font-semibold py-4 flex items-center justify-between px-4  lg:px-20 opacity-100 z-[200] blur-effect-theme"
                    }`}
            >
                {/* <div className="container pb-7">  */}
                {/* <Link to='contact' smooth={true} duration={500}><Button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-blue-600 hover:border-blue-600'>Hire Me</[...]
                 {/* </div> */}

                <div className="flex lg:flex-1">
                    <a href="/" className="flex -m-1.5 p-1.5">
                        {/* <span className=" ml-1"><img src={logo} className="w-[3rem] h-[3rem]" alt="logo" /></span> */}
                        <h1 className={`text-white font-semibold text-lg`}>iam_Ranjan</h1>
                    </a>
                </div>

                <div className="flex lg:hidden">
                    <button
                        type="button"
                        aria-label={mobileMenuOpen ? 'Close main menu' : 'Open main menu'}
                        className={`${!navState ? 'text-white' : 'text-black'} -m-2.5 inline-flex items-center justify-center rounded-md p-2.5`}
                        onClick={handleMobileMenuToggle}
                    >
                        <span className="sr-only">{mobileMenuOpen ? 'Close main menu' : 'Open main menu'}</span>
                        {mobileMenuOpen ? (
                            <XMarkIcon className={`${!navState ? 'text-white' : 'text-black'} h-7 w-7`} aria-hidden="true" />
                        ) : (
                            <Bars3Icon className={`${!navState ? 'text-white' : 'text-black'} h-7 w-7`} aria-hidden="true" />
                        )}
                    </button>
                </div>

                {/* menu */}
                <ul
                    className={`absolute left-0 right-0 top-full z-40 flex-col bg-slate-900/95 px-4 py-4 space-y-3 text-white font-semibold lg:static lg:flex lg:flex-row lg:items-center lg:justify-center lg:space-y-0 lg:space-x-3 lg:bg-transparent lg:px-3 ${mobileMenuOpen ? 'flex' : 'hidden'}`}
                >
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='home' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Home
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='about' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            About
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='experience' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Experience
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='skills' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Skills
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='projects' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Projects
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='services' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Services
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='achievement' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Achievements
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline hover:text-blue-500">
                        <Link to='contact' className="block px-3" smooth={true} duration={500} onClick={closeMobileMenu}>
                            Contact
                        </Link>
                    </li>
                    <li className="cursor-pointer hover:underline pl-3 hover:text-blue-500">
                        <a href="/Ranjan_CV.pdf" target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                            My_Resume
                        </a>
                    </li>
                </ul>

                {/*<div className="container flex md:pr-5 justify-end">
                    <Link to='contact' smooth={true} duration={500}>
                      <button type="button" className="text-white border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600 rounded-2xl">
                        Hire Me
                      </button>
                    </Link>
                </div> */}

                {/* <div className={`${!navState ? 'text-white' : 'text-black'} hidden lg:flex lg:flex-1 lg:justify-end lg:text-xl`}>
                    <a href="https://github.com/ranjangupta4590" target="_blank" rel="noreferrer"><FaGithub className={`mr-4 text-xl ${!navState ? 'text-white' : 'text-black'}`} /></a>
                    <a href="https://www.linkedin.com/in/ranjan-kumar-2023s/" target="_blank" rel="noreferrer"><FaLinkedinIn className={`mr-4 text-xl ${!navState ? 'text-white' : 'text-black'}`}/></a>
                    <a href="https://www.instagram.com/ranjan_gupta_official/" target="_blank" rel="noreferrer"><FaInstagram className={`mr-4 text-xl ${!navState ? 'text-white' : 'text-black'}`} /></a>
                    <a href="mailto:ranjangupta35558@gmail.com" target="_blank" rel="noreferrer"><FaEnvelope className={`mr-4 text-xl ${!navState ? 'text-white' : 'text-black'}`} /></a>
                </div> */}
                <div className={`text-white hidden lg:flex lg:flex-1 lg:justify-end lg:text-xl`}>
                    <a href="https://github.com/ranjangupta4590" target="_blank" rel="noreferrer"><FaGithub className={`mr-4 text-xl`} /></a>
                    <a href="https://www.linkedin.com/in/ranjan-kumar-2023s/" target="_blank" rel="noreferrer"><FaLinkedinIn className={`mr-4 text-xl`}/></a>
                    <a href="https://www.instagram.com/ranjan_gupta_official/" target="_blank" rel="noreferrer"><FaInstagram className={`mr-4 text-xl`} /></a>
                    <a href="mailto:mail.guptaranjan@gmail.com" target="_blank" rel="noreferrer"><FaEnvelope className={`mr-4 text-xl`} /></a>
                </div>




                




                

                {/* Social icons */}

                {/* <div className='fixed hidden lg:flex flex-col top-[35%] right-0 '>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center mr-[-100px] hover:mr-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://www.linkedin.com/in/ranjan-kumar-40117120a'
              target="_blank"
              rel='noreferrer'
            >
              <FaLinkedin size={30} />Linkedin
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center mr-[-100px] hover:mr-[-10px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://github.com/ranjangupta4590'
              target="_blank"
              rel='noreferrer'
            >
              <FaGithub size={30} />Github
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center mr-[-100px] hover:mr-[-10px] duration-300 bg-[#6fc2b0]'>
            <Link
              className='flex justify-between items-center w-full text-gray-300'
              to='contact'
            >
              <HiOutlineMail size={30} />Email
            </Link>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center mr-[-100px] hover:mr-[-10px] duration-300 bg-[#565f69]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href="/Ranjan_CV.pdf"
              target="_blank"
              rel='noreferrer'
            >
              <BsFillPersonLinesFill size={30} />Resume
            </a>
          </li>
        </ul>
      </div> */}
            </div>
            <hr className="w-full text-white" />
        </div>
    );
};

export default Navbar;
